export const PreloaderClassNames = {
  ACTIVE: 'active',
  SHOW: 'show',
  HIDE: 'hide',
  INITIAL: 'initial',
  PAGE_PRELOADER: 'js-hdms-page-preloader',
  BODY_ACTIVE: 'hdms-page-preloader-active'
};
